// Generated by purs version 0.15.15
import * as Color from "../Color/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Variant from "../Data.Variant/index.js";
import * as Record from "../Record/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var inj = /* #__PURE__ */ Data_Variant.inj();
var defaultUnit = {
    def: Data_Unit.unit
};
var defaultString = {
    def: ""
};
var defaultRLNilRow = {
    defaultRL: function (v) {
        return {};
    }
};
var defaultNumber = {
    def: 0.0
};
var defaultMaybe = /* #__PURE__ */ (function () {
    return {
        def: Data_Maybe.Nothing.value
    };
})();
var defaultColor = {
    def: Color.white
};
var defaultBoolean = {
    def: false
};
var defaultArray = {
    def: [  ]
};
var defaultRL = function (dict) {
    return dict.defaultRL;
};
var defaultRecord = function () {
    return function (dictDefaultRL) {
        return {
            def: defaultRL(dictDefaultRL)(Type_Proxy["Proxy"].value)
        };
    };
};
var def = function (dict) {
    return dict.def;
};
var defaultConst = function (dictDefault) {
    return {
        def: def(dictDefault)
    };
};
var defaultRLCons = function (dictDefaultRL) {
    var defaultRL1 = defaultRL(dictDefaultRL);
    return function (dictDefault) {
        var def1 = def(dictDefault);
        return function () {
            return function (dictIsSymbol) {
                var insert = Record.insert(dictIsSymbol)()();
                return function () {
                    return {
                        defaultRL: function (v) {
                            var tail = defaultRL1(Type_Proxy["Proxy"].value);
                            return insert(Type_Proxy["Proxy"].value)(def1)(tail);
                        }
                    };
                };
            };
        };
    };
};
var defaultVariant = function () {
    return function () {
        return function (dictDefault) {
            var def1 = def(dictDefault);
            return function (dictIsSymbol) {
                return {
                    def: inj(dictIsSymbol)(Type_Proxy["Proxy"].value)(def1)
                };
            };
        };
    };
};
export {
    def,
    defaultRL,
    defaultBoolean,
    defaultArray,
    defaultString,
    defaultNumber,
    defaultUnit,
    defaultColor,
    defaultMaybe,
    defaultConst,
    defaultVariant,
    defaultRecord,
    defaultRLNilRow,
    defaultRLCons
};
//# sourceMappingURL=index.js.map
